// Which tab ChatModelPicker opens on after its initial cred load.
//
// First-time setup (no saved key, not on the managed default) opens the
// provider/key form; everyone else — including managed-default tenants, who
// already have working chat on Origin's managed key — opens on the model
// picker rather than being forced into key config.
//
// Kept in its own module (not the component file) so it's unit-testable in the
// node test env without importing ChatModelPicker's DOM-touching dependency
// chain (the MCP registry registers a `window` listener at import time).
export function initialChatTab(creds) {
    return !creds.hasApiKey && !creds.managedDefault ? "provider" : "model";
}
